import IconHOC from '../IconHOC';

import { ReactComponent as DatabaseIcon } from './database.svg';

export const Database = IconHOC(DatabaseIcon);
